import Home from './views/Home.vue'
import Package from './views/Package.vue'
import MyPackage from './views/MyPackage.vue'
import PackageRecord from './views/PackageRecord.vue'
import DonglePackageRecord from './views/DonglePackageRecord.vue'
import Order from './views/Order.vue'
import OrderDetail from './views/OrderDetail.vue'

let routes = [
    {
        path: '/',
        redirect: '/buy',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-bar-chart', //图标样式class
        children: [
            { path: '/buy', component: Package, name: 'Buy'},  //套餐
            { path: '/myPackage', component: MyPackage, name: 'MyPackage'},  //我的套餐
            { path: '/packageRecord', component: PackageRecord, name: 'PackageRecord'},  //我的套餐-使用记录
            { path: '/donglePackageRecord', component: DonglePackageRecord, name: 'DonglePackageRecord'},  //我的套餐-使用记录-硬件锁
            { path: '/order', component: Order, name: 'Order'},  //订单            
            { path: '/orderDetail', component: OrderDetail, name: 'OrderDetail'},  //订单详情
        ]
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js